module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 35 35"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M8.38,5.8C5.23,12.73,6,19.18,11.86,24.47c5.5,5,12,5.41,18.75,2.54-1.9,3.84-7.67,8.46-15.28,8S1.29,28.9.18,21.73A15.35,15.35,0,0,1,8.38,5.8Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M26.16,14.74c-.06-.67-.11-1.3-.16-1.93-.09-1-.19-2.08-.23-3.13A.58.58,0,0,0,25.22,9c-1.72-.38-3.43-.79-5.16-1.2.07-.22.29-.21.45-.27C22,7,23.46,6.4,25,5.85c.38-.14.51-.32.47-.7-.13-1.5-.24-3-.35-4.51,0-.17,0-.35,0-.64l2.07,2.33c.48.54,1,1.08,1.44,1.64a.54.54,0,0,0,.74.18c1.55-.62,3.1-1.21,4.65-1.82l.41-.13c-.14.23-.21.38-.3.51C33.23,4,32.4,5.31,31.54,6.6a.51.51,0,0,0,.05.77c1,1.11,2,2.24,3,3.37.14.16.27.33.41.5-.2.11-.35,0-.51,0-1.57-.37-3.14-.73-4.71-1.12a.56.56,0,0,0-.71.28c-.82,1.31-1.68,2.6-2.52,3.9A1.14,1.14,0,0,1,26.16,14.74Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M26,19.53c-.67.47-1.23.9-1.84,1.27a.64.64,0,0,0-.3.92c.26.64.46,1.3.72,2.09-.76-.53-1.41-1-2-1.42a.5.5,0,0,0-.68,0c-.62.45-1.26.88-2,1.41.28-.83.48-1.53.75-2.21a.51.51,0,0,0-.26-.74,12.62,12.62,0,0,1-1.83-1.39c.73,0,1.47,0,2.2,0a.67.67,0,0,0,.81-.59,11.25,11.25,0,0,1,.72-2c.27.79.54,1.46.74,2.15a.5.5,0,0,0,.6.45A14.24,14.24,0,0,1,26,19.53Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M13.75,11.68c.19-.57.31-1,.49-1.47A.45.45,0,0,0,14,9.56a5.91,5.91,0,0,1-1.14-.91c.46,0,.91,0,1.36,0s.61-.08.7-.47.29-.84.48-1.38c.19.55.36,1,.49,1.44a.47.47,0,0,0,.58.41A6.32,6.32,0,0,1,18,8.74c-.4.29-.8.59-1.21.86a.39.39,0,0,0-.19.57c.17.44.31.9.51,1.5-.52-.36-.94-.61-1.33-.92a.47.47,0,0,0-.67,0C14.68,11.05,14.26,11.32,13.75,11.68Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e06d44b","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/sleep.vue
// module id = 1aa8c31f983c5c0a5d6b
// module chunks = 89